import type { HistoricalScoreSecondaryMetric } from './HistoricalScoreLineChart';
import type { ScoreHistoryPanelState } from '../utils/searchResultsHelpers';

export type HistoricalScoreSession = {
  rowKey: string;
  panel: ScoreHistoryPanelState;
  activeEvidenceYear: number | null;
  secondaryMetric: HistoricalScoreSecondaryMetric;
  fetchMin: number | null;
  fetchMax: number | null;
};

let session: HistoricalScoreSession | null = null;

export function saveHistoricalScoreSession(next: HistoricalScoreSession): void {
  session = next;
}

export function readHistoricalScoreSession(rowKey: string): HistoricalScoreSession | null {
  if (!rowKey || session?.rowKey !== rowKey) return null;
  return session;
}

export function clearHistoricalScoreSession(): void {
  session = null;
}
